import { omniAtom } from "src/utils/atoms";
import { MerchFlowCoreRange } from "@CommonApi/merchandise";

export interface ImportPlanogramsModalData {
  name: string;
  goLiveDate: Date;
  deactivationDate: Date | null;
  notes: string;
  coreRange: MerchFlowCoreRange;
}

export const importPlanogramsModalDataAtom = omniAtom({
  prefix: "src/modals/importPlanograms",
  key: "data",
  value: null as null | ImportPlanogramsModalData,
});
